import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CarServicesProvidersModule } from '@csProviders/car-services-providers.module';
import { environment } from '@environments/environment';

// import 'hammerjs';
declare const hammerjs;
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(CarServicesProvidersModule)
  .catch(err => console.log(err));